export enum OfferRequestStatus {
  Pending = 10,
  Accepted = 20,
  Rejected = 30,
  Cancelled = 40,
}

export const CUSTOM_OFFER_PRICE_OPTION_INDEX = 2
